import React from "react";

import {Route, Routes} from "react-router-dom";
import UserMain from "page/user/Main";
import UserDetail from "page/user/Detail";
import UserDeleted from "page/user/Deleted";
import UserReports from "page/user/Reports";
import UserBlocks from "page/user/Blocks";
import UserDummy from "page/user/Dummy";
import UserCreateDummy from "page/user/CreateDummy";
import ExcelUpload from "page/user/ExcelUpload";
import InsightMain from "page/insight/Main";
import InsightDetail from "page/insight/Detail";
import InsightReports from "page/insight/Reports";
import InsightHidden from "page/insight/Hidden";
import ChatMain from "page/chat/Main";
import ChatDetail from "page/chat/Detail";
import PaymentMain from "page/payment/Main";
import PaymentDetail from "page/payment/Detail";
import WithdrawalMain from "page/payment/WithdrawalMain";
import WithdrawalDetail from "page/payment/WithdrawalDetail";
import WithdrawalSummary from "page/payment/WithdrawalSummary";
import WithdrawalSummaryDetail from "page/payment/WithdrawalSummaryDetail";
import RagTraceMain from "page/rag/Main";
import RecommendationMain from "page/rag/RecommendationMain";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
function App() {
    return (
        <div className="App">
            <Routes>
                <Route path="/page/users" element={<UserMain />} />
                <Route path="/page/users/deleted" element={<UserDeleted />} />
                <Route path="/page/users/reports" element={<UserReports />} />
                <Route path="/page/users/blocks" element={<UserBlocks />} />
                <Route path="/page/users/dummy" element={<UserDummy />} />
                <Route path="/page/users/create-dummy" element={<UserCreateDummy />} />
                <Route path="/page/users/excel-upload" element={<ExcelUpload />} />
                <Route path="/page/users/detail" element={<UserDetail />} />
                <Route path="/page/insights" element={<InsightMain />} />
                <Route path="/page/insights/detail" element={<InsightDetail />} />
                <Route path="/page/insights/reports" element={<InsightReports />} />
                <Route path="/page/insights/hidden" element={<InsightHidden />} />
                <Route path="/page/chat" element={<ChatMain />} />
                <Route path="/page/chat/detail" element={<ChatDetail />} />
                <Route path="/page/payments" element={<PaymentMain />} />
                <Route path="/page/payments/detail" element={<PaymentDetail />} />
                <Route path="/page/payments/withdrawals" element={<WithdrawalMain />} />
                <Route path="/page/payments/withdrawals/summary" element={<WithdrawalSummary />} />
                <Route path="/page/payments/withdrawals/summary/detail" element={<WithdrawalSummaryDetail />} />
                <Route path="/page/payments/withdrawals/detail" element={<WithdrawalDetail />} />
                <Route path="/page/rag/traces" element={<RagTraceMain />} />
                <Route path="/page/rag/recommendations" element={<RecommendationMain />} />
            </Routes>
            <ToastContainer />
        </div>
    );
}

export default App;
